import React from 'react';
import zenoChat from '../../assets/zeno-chat-transparent.png';

/**
 * Loop de Zeno "vivo": parpadeo, balanceo suave y resplandor violeta,
 * animado con CSS puro sobre el arte real (sin video ni API externa).
 */
export default function ZenoIdle({ size = 120, className = '' }) {
  return (
    <div className={`zeno-idle ${className}`} style={{ width: size, height: size }}>
      <div className="zeno-idle__glow" />
      <img src={zenoChat} alt="Zeno" className="zeno-idle__img" draggable={false} />
      <span className="zeno-idle__blink zeno-idle__blink--left" />
      <span className="zeno-idle__blink zeno-idle__blink--right" />

      <style>{`
        .zeno-idle {
          position: relative;
          display: inline-block;
        }
        .zeno-idle__img {
          position: relative;
          z-index: 1;
          width: 100%;
          height: 100%;
          object-fit: contain;
          transform-origin: 50% 88%;
          animation: zenoIdleMotion 5.5s ease-in-out infinite;
        }
        .zeno-idle__glow {
          position: absolute;
          inset: 10%;
          z-index: 0;
          border-radius: 50%;
          background: radial-gradient(circle, rgba(124, 58, 237, 0.45), transparent 70%);
          filter: blur(14px);
          animation: zenoIdleGlow 3.4s ease-in-out infinite;
        }
        .zeno-idle__blink {
          position: absolute;
          z-index: 2;
          width: 15%;
          height: 9%;
          background: #05030a;
          border-radius: 50%;
          transform: translate(-50%, -50%) scaleY(0);
          animation: zenoIdleBlink 4.8s ease-in-out infinite;
        }
        .zeno-idle__blink--left { left: 37.4%; top: 45.1%; }
        .zeno-idle__blink--right { left: 58.1%; top: 45.1%; }

        @keyframes zenoIdleMotion {
          0%, 100% { transform: translateY(0) rotate(0deg); }
          25% { transform: translateY(-2%) rotate(-2deg); }
          50% { transform: translateY(-4%) rotate(0deg); }
          75% { transform: translateY(-2%) rotate(2deg); }
        }
        @keyframes zenoIdleGlow {
          0%, 100% { opacity: 0.5; transform: scale(1); }
          50% { opacity: 0.85; transform: scale(1.08); }
        }
        @keyframes zenoIdleBlink {
          0%, 92%, 100% { transform: translate(-50%, -50%) scaleY(0); }
          95%, 97% { transform: translate(-50%, -50%) scaleY(1); }
        }
        @media (prefers-reduced-motion: reduce) {
          .zeno-idle__img, .zeno-idle__glow, .zeno-idle__blink {
            animation: none !important;
          }
        }
      `}</style>
    </div>
  );
}
